import { HOST } from "../constants/HostConstants";
export const userDelete = async (
  user_id,
  email_address,
  { setPending },
  reason
) => {
  try {
    const res = await fetch(`${HOST}/api/user/userDelete`, {
      method: "POST",
      body: JSON.stringify({ user_id, email_address, reason }),
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });
    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch {
      return { success: false, error: text };
    }
    if (!res.ok) return { success: false, error: data?.error || "Failed" };
    setPending(Array.isArray(data) ? data : []);
    return { success: true, data };
  } catch (e) {
    return { success: false, error: e.message };
  }
};
